export default __webpack_public_path__ + "static/media/letUsKnow.bb670f0d.png";